import { useState, useContext, useRef, useCallback } from 'react';
import { useHistory, Link } from 'react-router-dom';

// cccv route
import { cccvRoute, keyplayRoute } from '@src/config/staticRouteConfig';
import { goToCCCV } from '@src/utils/LinkRoute';

// context
import { UserContext, IUserContext } from '@src/context/UserContext';

// custom hook
import useMediaQueryCustom from '@src/hooks/useMediaQueryCustom';

// utils
import {
  isKeyplayerByUserData,
  goToKeyplayPage,
  convertObjectToQueryString,
} from '@src/utils/helper';

// images
import LogoImageSvg from '@src/images/common/keyplay-logo.svg';
import ProfileImage from '@src/images/components/header/profile.png';
import MykeyplayImage from '@src/images/components/header/myKeyplay.png';
import MyCCCVImage from '@src/images/components/header/myCCCV.png';
import UsageHistoryImage from '@src/images/components/header/usageHistory.png';
import LogoutImage from '@src/images/components/header/logout.png';

import * as S from './styles';

export interface IMobileHeaderSearchBarWrapProps {
  active: boolean;
}

const staticRouter = {
  main: '/',
  login: '/login',
};

const GTMLabel = {
  loginButton: '로그인',
  nftButton: 'NFT 등록',
  myKeyplay: 'My Keyplay',
  myCCCV: 'My CCCV',
  myHistory: '이용내역',
  mySettlement: '정산관리',
  logoutButton: '로그아웃',
  profileButton: '프로필',
  searchButton: '검색',
};

export default function ResponsiveHeader(props: any) {
  const history = useHistory();
  const [submenuVibisility, setSubmenuVisibility] = useState(false);
  const { authToken, user, logoutUser } = useContext<IUserContext>(UserContext);

  const onClickMyProfile = () => {
    setSubmenuVisibility(!submenuVibisility);
  };

  const onClickRegisterNFT = () => {
    const destination = cccvRoute.mint;

    goToCCCV({
      queryStringObject: {
        access_token: authToken.accessToken,
        refresh_token: authToken.refreshToken,
        destination: destination,
        success_url: `${process.env.REACT_APP_URL}/user/${user.pageId}`,
      },
      routingType: 'location',
    });
  };

  const onClickMyKeyplay = () => {
    setSubmenuVisibility(false);

    const pathToMyKeyPlay = isKeyplayerByUserData(user?.roles)
      ? keyplayRoute.user.sell
      : keyplayRoute.user.owned;
    goToKeyplayPage(null, history, {
      pathname: pathToMyKeyPlay.replace(/#{pageId}/g, user?.pageId),
    });
  };

  const onClickMyCCCV = () => {
    setSubmenuVisibility(false);

    goToCCCV({
      queryStringObject: {
        access_token: authToken.accessToken,
        refresh_token: authToken.refreshToken,
        destination: cccvRoute.mycccv,
        success_url: 'none',
      },
      routingType: 'open',
    });
  };

  const onClickMyUsageHistory = () => {
    const destination = cccvRoute.usageHistory;

    setSubmenuVisibility(false);
    goToCCCV({
      queryStringObject: {
        access_token: authToken.accessToken,
        refresh_token: authToken.refreshToken,
        destination: destination.replace(/#{pageId}/g, user?.pageId),
        success_url: 'none',
      },
      routingType: 'open',
    });
  };

  const onClickMyPaymentHistory = () => {
    const destination = cccvRoute.paymentHistory;

    setSubmenuVisibility(false);
    goToCCCV({
      queryStringObject: {
        access_token: authToken.accessToken,
        refresh_token: authToken.refreshToken,
        destination: destination.replace(/#{pageId}/g, user?.pageId),
        success_url: 'none',
      },
      routingType: 'open',
    });
  };

  const onClickLogout = () => {
    setSubmenuVisibility(false);
    logoutUser();
  };

  return (
    <>
      <S.HeaderContainer {...props}>
        <S.HeaderContainerWrapper className="ResponsiveHeader__Inner">
          <Link to={{ pathname: staticRouter.main }}>
            <S.LogoImg src={LogoImageSvg} alt="Lotte Open" />
          </Link>
          {authToken ? (
            <S.HeaderRightContainer className="HeaderRightContainer">
              <S.ProfileWrap>
                <S.MyProfileButton
                  onClick={onClickMyProfile}
                  gtmLabel={GTMLabel.profileButton}
                  type="button"
                >
                  <S.MyProfileButtonImg
                    src={user ? user.profileImgUrl : ProfileImage}
                    alt={`${user?.pageId} 프로필 이미지`}
                  />
                </S.MyProfileButton>

                {submenuVibisility && (
                  <>
                    <S.SubmenuContainer>
                      <S.Submenu onClick={onClickMyKeyplay}>
                        <S.SubmenuIcon
                          src={MykeyplayImage}
                          width={18}
                          height={16}
                        />
                        <S.SubmenuTitleText marginLeft={13}>
                          My Pass
                        </S.SubmenuTitleText>
                      </S.Submenu>
                      <S.Submenu onClick={onClickLogout}>
                        <S.SubmenuIcon
                          src={LogoutImage}
                          width={15}
                          height={17}
                        />
                        <S.SubmenuTitleText marginLeft={15}>
                          로그아웃
                        </S.SubmenuTitleText>
                      </S.Submenu>
                    </S.SubmenuContainer>
                  </>
                )}
              </S.ProfileWrap>
            </S.HeaderRightContainer>
          ) : (
            <S.HeaderRightContainer>
              <S.LoginButton
                to={{
                  pathname: staticRouter.login,
                  search: convertObjectToQueryString({
                    login_return_url: encodeURIComponent(
                      history.location.pathname + history.location.search,
                    ),
                  }),
                }}
                rel="nofollow"
              >
                로그인
              </S.LoginButton>
            </S.HeaderRightContainer>
          )}
        </S.HeaderContainerWrapper>
      </S.HeaderContainer>
    </>
  );
}
